
import { debugLog } from '../../utils/debugLogger';

interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

const cache = new Map<string, CacheEntry<any>>();
// 4 ore di cache per i dati storici
const HISTORY_CACHE_TTL = 4 * 60 * 60 * 1000; 

export const serverCacheService = {
  get<T>(key: string): T | null {
    const entry = cache.get(key);
    if (!entry) {
      debugLog('ssr', `MISS for key: ${key}`, undefined, 'SSR Cache');
      return null;
    }

    const isExpired = Date.now() - entry.timestamp > HISTORY_CACHE_TTL;
    if (isExpired) {
      cache.delete(key);
      debugLog('ssr', `EXPIRED cache for key: ${key}`, undefined, 'SSR Cache');
      return null;
    }
    
    debugLog('ssr', `HIT for key: ${key}`, undefined, 'SSR Cache');
    return entry.data as T;
  },

  set<T>(key: string, data: T): void {
    const entry: CacheEntry<T> = {
      data,
      timestamp: Date.now(),
    };
    cache.set(key, entry);
    debugLog('ssr', `SET data for key: ${key}`, undefined, 'SSR Cache');
  },

  removeByPattern(pattern: RegExp): number {
    let removedCount = 0;
    for (const [key] of cache) {
      if (pattern.test(key)) {
        cache.delete(key);
        removedCount++;
      }
    }
    debugLog('ssr', `Removed ${removedCount} entries matching pattern: ${pattern}`, undefined, 'SSR Cache');
    return removedCount;
  },

  clear(): void {
    cache.clear();
    debugLog('ssr', 'Server cache cleared', undefined, 'SSR Cache');
  },

  getStats(): { totalEntries: number; keys: string[] } {
    return {
      totalEntries: cache.size,
      keys: Array.from(cache.keys()),
    };
  },
};
